import { render, staticRenderFns } from "./OrdersGroup.vue?vue&type=template&id=d076bcc4&scoped=true&"
import script from "./OrdersGroup.vue?vue&type=script&lang=js&"
export * from "./OrdersGroup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersGroup.vue?vue&type=style&index=0&id=d076bcc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d076bcc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
